import { useRef } from 'react';

/**
 * Wraps a hidden `<input type="file">`: exposes a ref, a helper to open the
 * native file dialog, and a helper to reset its value (so selecting the same
 * file twice still fires `change`).
 */
export const useFileInput = () => {
  const inputRef = useRef<HTMLInputElement>(null);

  const openFileDialog = () => inputRef.current?.click();

  const resetFileInput = () => {
    if (inputRef.current) inputRef.current.value = '';
  };

  return { inputRef, openFileDialog, resetFileInput };
};
